import { type ReactElement } from 'react'
import { Vector3 } from 'three'
import Text3DThreeDoubleSided from 'src/components/scene/Text3DThreeDoubleSided'
import { getContrastTextColor } from 'src/utils/color'
import { ENVELOPE_LABEL_BORDER_WIDTH } from './utils'

interface Props {
  position: Vector3
  isAboveAxis: boolean
  text: string
  color: string
  scale: number
  textXDirection: Vector3
  textYDirection: Vector3
}

/**
 * Value label at an envelope extreme, styled like the 3D line load labels (colored box with
 * contrasting text and border, line load text scale), drawn on top of the scene so that elements
 * in front of it do not hide it. Sits on top of `position` when the ordinate points up and hangs
 * below it when it points down.
 */
const EnvelopeExtremeLabel = ({
  position,
  isAboveAxis,
  text,
  color,
  scale,
  textXDirection,
  textYDirection,
}: Props): ReactElement => {
  const textColor = getContrastTextColor(color)

  return (
    <Text3DThreeDoubleSided
      textLines={[text]}
      color={textColor}
      backgroundColor={color}
      borderWidth={ENVELOPE_LABEL_BORDER_WIDTH}
      borderColor={textColor}
      position={position}
      anchorLocation={isAboveAxis ? 'bottom' : 'top'}
      scale={scale}
      textXOrientation={textXDirection}
      textYOrientation={textYDirection}
      disableDepthTest
    />
  )
}

export default EnvelopeExtremeLabel
